import { render, staticRenderFns } from "./detailExamine.vue?vue&type=template&id=206305c2&scoped=true"
import script from "./detailExamine.vue?vue&type=script&lang=js"
export * from "./detailExamine.vue?vue&type=script&lang=js"
import style0 from "./detailExamine.vue?vue&type=style&index=0&id=206305c2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206305c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('206305c2')) {
      api.createRecord('206305c2', component.options)
    } else {
      api.reload('206305c2', component.options)
    }
    module.hot.accept("./detailExamine.vue?vue&type=template&id=206305c2&scoped=true", function () {
      api.rerender('206305c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/examine/components/detailExamine.vue"
export default component.exports